<script setup lang="tsx">
import type { Column } from '@/stores/column'
import ClearButton from './ClearButton.vue'
import { commonProps } from './props'
import { computed, onBeforeUnmount } from 'vue'

const model = defineModel<Column>({ required: true })
const props = defineProps(commonProps)

const internalModel = computed<string | undefined>({
	get: () => model.value.filter,
	set: (value) => {
		model.value.filter = value
	},
})
onBeforeUnmount(() => (model.value.filter = undefined))
</script>

<template>
	<div class="w-100 position-relative d-inline-flex align-items-center">
		<input
			class="form-control"
			type="text"
			size="10"
			:id="props.id"
			:data-test="props.dataTest"
			:disabled="props.disabled"
			:placeholder="model.label + '...'"
			v-model="internalModel"
		/>
		<ClearButton v-if="internalModel?.length" @click="internalModel = undefined"></ClearButton>
	</div>
</template>
